module.exports = __webpack_public_path__ + "img/Master-Games.eu.e113502b.png";